import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { sort } from '@ember/object/computed';
import { action } from '@ember/object';
import { TellerType } from 'mewe/constants';
import { toTeller } from 'mewe/fetchers/fetch-stories';

export default class MwJournalsList extends Component {
  @service dynamicDialogs;

  sorting = ['lastStoryAddedAt:desc'];
  @sort('args.journals.items', 'sorting') journalsSorted;

  @action
  open(journal) {
    const tellerData = toTeller({
      id: this.args.contact.id,
      storytellerType: TellerType.USER,
    });
    tellerData.userStoryteller = this.args.contact; // contact is EmberObject, can't be serialized

    let params = {
      tellerData,
      journalsList: this.args.journals.items,
      initialJournalId: journal.id,
    };

    this.dynamicDialogs.openDialog('stories-dialog', params);
  }
}
